module.exports = __webpack_public_path__ + "static/media/ev.7d15c16c.jpeg";